import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const BiomassBurningCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningEditor')
  const detail = params.row.findDetail({ traitId, year })

  return (
    <Stack>
      <Typography>{detail?.result?.percentage === 0 ? t('no') : t('yes')}</Typography>
      <Typography variant="body2" color="text.secondary">
        {t('percentValue', { count: detail?.result?.percentage })}
      </Typography>
    </Stack>
  )
}
